export enum Resource {
    Wood = 'r1',
    Clay = 'r2',
    Iron = 'r3',
    Crop = 'r4',
}

export type Resources = {
    [Resource.Wood]: number,
    [Resource.Clay]: number,
    [Resource.Iron]: number,
    [Resource.Crop]: number,
}

export function getNewResources(wood: number = 0, clay: number = 0, iron: number = 0, crop: number = 0): Resources {
    return {
        [Resource.Wood]: wood,
        [Resource.Clay]: clay,
        [Resource.Iron]: iron,
        [Resource.Crop]: crop,
    }
}

export function getProducerBuilding(resource: Resource) {
    switch (resource) {
        case Resource.Wood: return 1;
        case Resource.Clay: return 2;
        case Resource.Iron: return 3;
        case Resource.Crop: return 4;
    }
}

export function addResources(a: Resources, b: Resources): Resources {
    const c = getNewResources();
    for (const resource in a) {
        c[resource] = a[resource] + b[resource];
    }
    return c;
}

export function multiplyResources(resources: Resources, factor: number): Resources {
    const product = getNewResources();
    for (const resource in resources) {
        product[resource] = resources[resource] * factor;
    }
    return product;
}

export function sumResources(resources: Resources): number {
    return Object.values(resources).reduce((a, b) => a + b, 0);
}

export function areResourcesEqual(a: Resources, b: Resources): boolean {
    for (const resource in a) {
        if (a[resource] !== b[resource]) {
            return false;
        }
    }
    return true;
}

export function resourcesToArray(resources: Resources): Array<number> {
    return [
        resources[Resource.Wood],
        resources[Resource.Clay],
        resources[Resource.Iron],
        resources[Resource.Crop],
    ];
}
